import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Facebook, Youtube } from "lucide-react";

export const CONTACT = {
  email: "marizematax@gmail.com",
  phoneDisplay: "(813) 728-0702",
  phoneTel: "tel:+18137280702",
  facebook: "https://facebook.com/Marizema%20Tax%20Service",
  youtube: "https://youtube.com/mMarizema%20Tax%20Service",
  location: "Tampa, Florida, United States",
};

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B2545] border-t border-[#C9A227]/30 mt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img src="/icons/logo.png" alt="Marizema Tax Service LLC logo" className="h-20 w-auto rounded-md bg-white p-1.5" />
          <p className="mt-4 text-sm text-slate-300 leading-relaxed max-w-xs">
            Professional tax and bookkeeping solutions for individuals and small businesses.
            Accurate, reliable, and tailored to your needs.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest font-semibold text-[#D4AF37] mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-link-services" to="/our-services" className="text-slate-300 hover:text-white transition-colors">Our Services</Link></li>
            <li><Link data-testid="footer-link-bookkeeping" to="/marizema-bookkeeping-service" className="text-slate-300 hover:text-white transition-colors">Marizema Bookkeeping</Link></li>
            <li><Link data-testid="footer-link-about" to="/about-us" className="text-slate-300 hover:text-white transition-colors">About Us</Link></li>
            <li><Link data-testid="footer-link-blog" to="/tax-tips-blog" className="text-slate-300 hover:text-white transition-colors">Tax Tips Blog</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="text-slate-300 hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-widest font-semibold text-[#D4AF37] mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors">
                <Mail size={16} className="text-[#D4AF37]" /> {CONTACT.email}
              </a>
            </li>
            <li>
              <a data-testid="footer-phone-link" href={CONTACT.phoneTel} className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors">
                <Phone size={16} className="text-[#D4AF37]" /> {CONTACT.phoneDisplay}
              </a>
            </li>
            <li className="flex items-center gap-2 text-slate-300">
              <MapPin size={16} className="text-[#D4AF37]" /> {CONTACT.location}
            </li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a data-testid="footer-social-facebook" href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"
              className="w-9 h-9 rounded-full bg-[#14375E] border border-[#C9A227]/40 flex items-center justify-center text-slate-200 hover:text-[#D4AF37] transition-colors">
              <Facebook size={16} />
            </a>
            <a data-testid="footer-social-youtube" href={CONTACT.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"
              className="w-9 h-9 rounded-full bg-[#14375E] border border-[#C9A227]/40 flex items-center justify-center text-slate-200 hover:text-[#D4AF37] transition-colors">
              <Youtube size={16} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#C9A227]/20 py-5 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} Marizema Tax Service LLC. All rights reserved.
      </div>
    </footer>
  );
}
